import { IsBoolean, IsDefined, IsInt, IsNumber, IsOptional } from 'class-validator';
import { BaseDto } from '../base.dto';

export class CurrencyDenominationsDto extends BaseDto  {
  @IsDefined()
  @IsNumber({maxDecimalPlaces: 2})
  value: number;

  @IsDefined()
  @IsInt()
  currencyId: number;

  @IsOptional()
  @IsInt()
  bagQuantity: number;

  @IsDefined()
  @IsBoolean()
  isCoin: boolean;

  @IsDefined()
  @IsInt()
  sequence: number;
}
